module.exports = __webpack_public_path__ + "static/img/advantages-1.137735f5.png";